import React, { Component } from 'react'
import { DayPicker } from 'react-day-picker'
import Icon from "../../../../../../images/settings-icons/setting-check-in.png";
import { Accordion } from "./components/setting-accordion";
import { SaveButton } from "./components/save-button";
import { updateAuxiliary } from "../../../../../../api";
import styled from "styled-components";

const modifiersStyles = {
  selected: {
    color: '#FFF',
    background: '#05d141',
  }
}

const Container = styled.div`
  h2 {
    font-size: 1.25rem;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;

class UpdateCheckInDay extends Component {
  constructor(props) {
    super(props)
    this.state = {
      desiredDayOfWeek: null,
      expanded: false,
      disableSubmit: true,
      isSubmitting: false,
      show: false,
    }
  }

  handlePanelChange = (event, expanded) => {
    this.setState({ expanded: expanded })
  }

  handleDayClick = (day) => {
    const dateLimit = new Date(this.props.nextPossibleWeighInDate.getFullYear(), this.props.nextPossibleWeighInDate.getMonth(), this.props.nextPossibleWeighInDate.getDate() + 7)
    if(day >= this.props.nextPossibleWeighInDate && day < dateLimit) {
      const desiredDayOfWeek = day.getDay()
      this.setState({ desiredDayOfWeek: desiredDayOfWeek, disableSubmit: desiredDayOfWeek === this.props.desiredDayOfWeek })
    }
  }

  handleNoPreference = () => {
    this.setState({ desiredDayOfWeek: 7, disableSubmit: this.props.desiredDayOfWeek === 7 })
  }

  handleSubmit = () => {
    const desiredDayOfWeek = this.state.desiredDayOfWeek === null ? this.props.desiredDayOfWeek : this.state.desiredDayOfWeek
    let desiredNextWeighInDate
    if(desiredDayOfWeek === 7) {
      desiredNextWeighInDate = this.props.defaultNextWeighInDate
    } else {
      let dayOffset = desiredDayOfWeek - this.props.nextPossibleWeighInDate.getDay()
      if(dayOffset < 0) {
        dayOffset += 7
      }
      desiredNextWeighInDate = new Date(this.props.nextPossibleWeighInDate.getFullYear(), this.props.nextPossibleWeighInDate.getMonth(), this.props.nextPossibleWeighInDate.getDate() + dayOffset)
    }
    const data = {
      check_in_date: desiredDayOfWeek === 7 ? null : desiredNextWeighInDate
    }
    this.setState({ isSubmitting: true })

    updateAuxiliary(this.props.userId, this.props.portalId, data).then((res) => { 
      setTimeout(() => {
        this.setState({ isSubmitting: false });
        this.props.openSnackbar('Setting has been updated', false);
        this.props.loadPortalAccount();
      }, 1000);
    }).catch((err) => {
      setTimeout(() => {
        this.setState({ isSubmitting: false });
        this.props.openSnackbar('Setting failed to update', true)
      }, 1000);
      console.log('failed update: ', err)
    });
  }

  render() {
    const desiredDayOfWeek = this.state.desiredDayOfWeek === null ? this.props.desiredDayOfWeek : this.state.desiredDayOfWeek
    const dayOfWeekOptions = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday','Saturday', "'No preference'"]
    let desiredNextWeighInDate
    if(desiredDayOfWeek === 7) {
      desiredNextWeighInDate = this.props.defaultNextWeighInDate
    } else {
      let dayOffset = desiredDayOfWeek - this.props.nextPossibleWeighInDate.getDay()
      if(dayOffset < 0) {
        dayOffset += 7
      }
      desiredNextWeighInDate = new Date(this.props.nextPossibleWeighInDate.getFullYear(), this.props.nextPossibleWeighInDate.getMonth(), this.props.nextPossibleWeighInDate.getDate() + dayOffset)
    }    const disabledDays = [
      { before: this.props.nextPossibleWeighInDate },
      { after: new Date(this.props.nextPossibleWeighInDate.getFullYear(), this.props.nextPossibleWeighInDate.getMonth(), this.props.nextPossibleWeighInDate.getDate() + 6) }
    ]
    const monthSpan = this.props.nextPossibleWeighInDate.getDate() > 21

    return (
      <Accordion
        show={this.state.show}
        setShow={(val) => this.setState({show: val})}  
        icon={Icon}
        settingName="Check-in day"
        currentSetting={dayOfWeekOptions[this.props.desiredDayOfWeek]}
        description="Select this user's preferred check-in day"
        roundBottom
        alternateColor
      >
        <Container>
          <DayPicker
            modifiersStyles={modifiersStyles}
            disabled={disabledDays}
            selected={desiredNextWeighInDate}
            // month={desiredNextWeighInDate}
            // disableNavigation={!monthSpan}
            fixedWeeks={monthSpan}
            onDayClick={this.handleDayClick}
          />
          {desiredDayOfWeek !== this.props.desiredDayOfWeek && (
          <p>Changing selection to {dayOfWeekOptions[desiredDayOfWeek]}</p>
          )}
          <ButtonRow>
            {!this.state.isSubmitting && desiredDayOfWeek !== 7 && (
              <SaveButton
                disabled={false}
                isLoading={false}
                text="No preference"
                onClick={this.handleNoPreference}
              />
            )}
            <SaveButton
              disabled={this.state.disableSubmit}
              isLoading={this.state.isSubmitting}
              onClick={this.handleSubmit}
            />
          </ButtonRow>
        </Container>
      </Accordion>
    )
  }
}

export default UpdateCheckInDay;

